// UI 상태 인터페이스 정의 제거됨
import initialLayouts from '@resources/assets/layoutData';

// Actions
const SET_SIDEBAR_COLLAPSED = "ui/SET_SIDEBAR_COLLAPSED";
const SET_NAVIDATA = "ui/SET_NAVIDATA";
const SET_SIDEBAR_TOGGLED = "ui/SET_SIDEBAR_TOGGLED";
const SET_UUID = "ui/SET_UUID";
const SET_THEME = "ui/SET_THEME";
//const SET_THEME_TYPE = "ui/SET_THEME_TYPE";
const SET_LANG = "ui/SET_LANG";
const SET_LANG_LIST = "ui/SET_LANG_LIST";
const UPDATE_WIDGET_DATA = "ui/UPDATE_WIDGET_DATA";
const UPDATE_LAYOUT = "ui/UPDATE_LAYOUT";
const SET_BREAKPOINT = "ui/SET_BREAKPOINT";
const ADD_WIDGET = "ui/ADD_WIDGET";
const REMOVE_WIDGET = "ui/REMOVE_WIDGET";

// 액션 생성 함수
export const setSidebarCollapsed = (sidebarCollapsed) => ({ type: SET_SIDEBAR_COLLAPSED, sidebarCollapsed });
export const setSidebarToggled = (sidebarToggled) => ({ type: SET_SIDEBAR_TOGGLED, sidebarToggled });
export const setNaviData = (naviData) => ({ type: SET_NAVIDATA, naviData });
export const setUuid = (uuid) => ({ type: SET_UUID, uuid });
export const setTheme = (theme) => ({ type: SET_THEME, theme });
//export const setThemeType = (themeType) => ({ type: SET_THEME_TYPE, themeType });
export const setLang = (lang) => ({ type: SET_LANG, lang });
export const setLangList = (langList) => ({ type: SET_LANG_LIST, langList });
export const updateWidgetData = widgets => ({ type: UPDATE_WIDGET_DATA, widgets });

export const updateLayout = (breakpoint, layout) => ({
  type: UPDATE_LAYOUT,
  layout
});

export const setBreakpoint = (breakpoint) => ({
  type: SET_BREAKPOINT,
  payload: breakpoint
});

export const addWidget = (widget) => ({
  type: ADD_WIDGET,
  payload: widget
});

export const removeWidget = (widgetId) => ({
  type: REMOVE_WIDGET,
  payload: widgetId
});

// 초깃값
const initialState = {
  sidebarCollapsed: false,
  sidebarToggled: false,
  naviData: {},
  uuid: '',
  theme: localStorage.getItem('studioTheme') || 'light',
  themeType: localStorage.getItem('themeType') || 'light',
  lang: "ko-KR",
  langList: [],
  widgets: {
    'recentServices': {
      id: 'recentServices',
      title: 'dashboard.widgets.recent_services',
      data: []
    },
    'csmsHealth': {
      id: 'csmsHealth',
      title: 'dashboard.widgets.csms_health',
      data: []
    },
  },
  layouts: initialLayouts,
  currentBreakpoint: 'lg'
};

export default function ui(state = initialState, action) {
  switch (action.type) {
    case SET_SIDEBAR_COLLAPSED:
      return {
        ...state,
        sidebarCollapsed: action.sidebarCollapsed
      };
    case SET_SIDEBAR_TOGGLED:
      return {
        ...state,
        sidebarToggled: action.sidebarToggled
      };
    case SET_NAVIDATA:
      return {
        ...state,
        naviData: action.naviData
      };
    case SET_UUID:
      return {
        ...state,
        uuid: action.uuid
      };
    case SET_THEME:
      localStorage.setItem('studioTheme', action.theme);
      return {
        ...state,
        theme: action.theme
      };
    /*
    case SET_THEME_TYPE:
      localStorage.setItem('themeType', action.themeType);
      return {
        ...state,
        themeType: action.themeType
      };
    */
    case SET_LANG:
      return {
        ...state,
        lang: action.lang
      };
    case SET_LANG_LIST:
      return {
        ...state,
        langList: action.langList
      };
    case UPDATE_WIDGET_DATA:
      return {
        ...state,
        widgets: action.widgets
      };
    // const { id, data } = action.payload;
    // return {
    //   ...state,
    //   widgets: {
    //     ...state.widgets,
    //     [id]: {
    //       ...state.widgets[id],
    //       data
    //     }
    //   }
    //};
    case UPDATE_LAYOUT:
      const { breakpoint, layout } = action.payload;
      return {
        ...state,
        layouts: {
          ...state.layouts,
          [breakpoint]: layout
        }
      };
    case SET_BREAKPOINT:
      return {
        ...state,
        currentBreakpoint: action.payload
      };
    case ADD_WIDGET:
      const widget = action.payload;
      return {
        ...state,
        widgets: {
          ...state.widgets,
          [widget.id]: widget
        }
      };
    case REMOVE_WIDGET:
      const widgetId = action.payload;
      const { [widgetId]: _, ...remainingWidgets } = state.widgets;
      const updatedLayouts = Object.keys(state.layouts).reduce((acc, bp) => {
        acc[bp] = state.layouts[bp].filter(item => item.i !== widgetId);
        return acc;
      }, {});

      return {
        ...state,
        widgets: remainingWidgets,
        layouts: updatedLayouts
      };
    default:
      return state;
  }
}
